import React from 'react'
import './header.css'
import HeaderSocial from './HeaderSocial'
import { personalInfo } from '../../data'

const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h5>Hello it is</h5>
        <h1>{personalInfo.name}</h1>
        <h5 className="text-light">{personalInfo.heading}</h5>

        <div className='cta'>
          <a className='btn btn-primary' href="#contact">Let's Talk</a>
        </div>

        <HeaderSocial />
        <div className="me">
          <img src={personalInfo.photo} alt="" aria-hidden="true" />
        </div>

        <a href="#contact" className='scroll__down'>Scroll Down</a>
      </div>
    </header>
  )
}

export default Header
